<template>
  <div :class="wrapperClass">
    <div class="mb-1"><b>Job Status</b></div>
    <Select
      v-model="jobStatusId"
      :options="jobStatuses"
      search
      :name="fieldName"
      no-label
      :field-error="
        v$.$errors.find(({ $property }) => $property === 'jobStatusId')
          ?.$message
      "
      full-width
      :allow-empty="false"
      data-cy="job-status-select"
    ></Select>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    },
    wrapperClass: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      jobStatusId: {
        requiredIf: requiredIf(this.required),
        $autoDirty: true
      }
    };
  },
  data() {
    return {
      fieldName: "Job Status"
    };
  },
  computed: {
    ...mapState({
      jobStatuses({ jobStatuses }) {
        return jobStatuses.map((js) => ({
          ...js,
          label: js.name,
          value: js.id
        }));
      }
    }),
    jobStatusId: {
      get() {
        return this.modelValue || this.jobStatuses[0]?.id;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  mounted() {
    if (!this.jobStatuses.length) {
      this.fetchJobStatuses();
    }
  },
  methods: {
    ...mapActions(["fetchJobStatuses"])
  }
};
</script>

<style lang="scss" scoped></style>
